import { ProductType } from './types'

const OST_BASE = {
  defaultPage: 'program-supports',
  entryPoint: 'C1bnxN0N5hhttOeJeF81e',
  productName: 'ost',
  skuCode: ProductType.OST.skuCode,
}

export const createOstProduct = ({ name, themeName }) => ({
  ...OST_BASE,
  name,
  themeName,
})

export const createKitProduct = ({
  alternateNames,
  defaultPage,
  entryPoint,
  name,
  productName,
  skuCode,
  themeName,
}) => ({
  ...(alternateNames ? { alternateNames } : {}),
  ...(defaultPage ? { defaultPage } : {}),
  entryPoint,
  name,
  productName,
  skuCode,
  themeName,
})

export const createSelForAdultsProduct = ({
  entryPoint,
  name,
  productName,
}) => ({
  defaultPage: 'modules',
  entryPoint,
  name,
  productName,
  skuCode: null,
  themeName: 'sela',
})
